import { Event } from '@zajno/common/observing/event';
import { useCallback, useLayoutEffect, useRef } from 'react';

export const UpdateEchoes = new Event<EchoFilters>();


export const DirectionalLightEcho = (props: Props<THREE.DirectionalLight>) => {
    const ref = useEcho(props.source);
    return <directionalLight ref={ref} />;
};

export const HemisphereLightEcho = (props: Props<THREE.HemisphereLight>) => {
    const ref = useEcho(props.source);
    return <hemisphereLight ref={ref} />;
};


type Base<T> = { name: string, copy: (other: T) => any };

type Props<T extends Base<T>> = {
    source: T;
};

type AnyClass = new (...args: any[]) => any;

export type EchoFilters = {
    name?: string;
    type?: AnyClass;
};

export namespace EchoFilters {
    export function shouldSkip(target: Base<any>, filter: EchoFilters) {
        if (!filter || !target) {
            return false;
        }

        return filter.name && filter.name !== target.name
            || filter.type && !(target instanceof filter.type);
    }
}


const useEcho = <T extends Base<T>>(source: T) => {
    const ref = useRef<T>();

    const doUpdate = useCallback(() => {
        ref.current?.copy(source);
    }, [source]);

    useLayoutEffect(() => {
        doUpdate();
        return UpdateEchoes.on(filter => {
            if (!EchoFilters.shouldSkip(ref.current, filter)) {
                doUpdate();
            }
        });
    }, [doUpdate]);

    return ref;
};
